import React from 'react'
import ReactDOM from 'react-dom'
import { CookiesProvider } from 'react-cookie'
import { BrowserRouter } from 'react-router-dom'
import StoreProvider from './stores/context'
import App from './layouts/app'

ReactDOM.render(
    <StoreProvider>
        <BrowserRouter>
            <CookiesProvider>
                <App />
            </CookiesProvider>
        </BrowserRouter>
    </StoreProvider>,
    document.querySelector('header'),
)



// WEBPACK FOOTER //
// ./src/m_header/index.js